const THEME_KEY = 'h5_theme'
const THEME_WARM = 'warm'
const THEME_FRESH = 'fresh'

export function getTheme() {
  try {
    const t = localStorage.getItem(THEME_KEY)
    return t === THEME_FRESH ? THEME_FRESH : THEME_WARM
  } catch {
    return THEME_WARM
  }
}

export function setTheme(theme) {
  const value = theme === THEME_FRESH ? THEME_FRESH : THEME_WARM
  try {
    localStorage.setItem(THEME_KEY, value)
  } catch (_) { /* ignore */ }
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.setAttribute('data-theme', value)
  }
  return value
}

export function applyTheme() {
  setTheme(getTheme())
}

export { THEME_WARM, THEME_FRESH }
